import { CheckCircle2, Wallet } from 'lucide-react';
import { Button } from '@components/ui';

export default function QuickExpenseWidget({ items, onPayAction, formatCurrency }) {
    return (
        <div className="bg-bg-primary rounded-2xl border border-border-light overflow-hidden h-full flex flex-col">
            <div className="p-4 border-b border-border-light bg-bg-secondary/30 flex justify-between items-center">
                <h3 className="font-semibold text-text-primary flex items-center gap-2">
                    <Wallet size={16} className="text-text-tertiary" />
                    Bu Ay Planlı Giderler
                </h3>
            </div>

            <div className="divide-y divide-border-light overflow-y-auto max-h-[300px] scrollbar-thin">
                {items.length === 0 ? (
                    <div className="p-8 text-center text-text-muted text-sm">
                        Planlı ödeme bulunmuyor.
                    </div>
                ) : (
                    items.map((item) => (
                        <div key={item.id} className="p-4 hover:bg-bg-hover/50 transition-colors flex items-center justify-between group">
                            <div>
                                <div className="font-medium text-text-primary text-sm">{item.category}</div>
                                <div className="text-xs text-text-secondary">{item.description}</div>
                                <div className="text-xs text-text-muted mt-0.5">{new Date(item.date).toLocaleDateString('tr-TR')}</div>
                            </div>

                            <div className="text-right">
                                <div className="font-bold text-text-primary mb-2">{formatCurrency(item.amount)}</div>
                                <Button
                                    size="xs"
                                    variant="secondary"
                                    className="text-xs h-7"
                                    onClick={() => onPayAction(item)}
                                >
                                    Ödendi İşaretle
                                </Button>
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
}
